// toastConfig.js
import { BaseToast, ErrorToast } from 'react-native-toast-message';
import Colours from '../utils/Colours';

const toastConfig = {
    success: (props) => (
        <BaseToast
            {...props}
            style={{ borderLeftColor: '#0BDA51' }}
            text1Style={{
                fontSize: 16,
                fontWeight: 'normal',
                fontFamily: 'Sen-Bold',
                color: '#0BDA51',
            }}
            text2Style={{
                fontSize: 14,
                fontWeight: 'normal',
                fontFamily: 'Sen-Regular',
                color: '#0BDA51',
            }}
            text2NumberOfLines={3}
        />
    ),
    error: (props) => (
        <ErrorToast
            {...props}
            style={{ borderLeftColor: 'red' }}

            text1Style={{
                fontSize: 16,
                fontWeight: 'normal',
                fontFamily: 'Sen-Bold',
                color: 'red',
            }}
            text2Style={{
                fontSize: 14,
                fontWeight: 'normal',
                fontFamily: 'Sen-Regular',
                color: 'red',
            }}
            text2NumberOfLines={3}
        />
    ),
};

export default toastConfig;
